module.exports = __webpack_public_path__ + "67300116a5bcf6e34bf843a59fa8b3b8.png";